import { useTranslation } from 'react-i18next'
import { SidebarTab } from './AccountPresenter'
import { AccountSidebarTab } from './AccountSidebarTab'

interface AccountSidebarProps {
  onTabChange: (tab: SidebarTab) => void
  tabs: any[]
  activeTab: SidebarTab
}

export const AccountSidebar = ({
  onTabChange,
  tabs,
  activeTab,
}: AccountSidebarProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="account-sidebar-container">
      <div className="filter-dock-action-buttons-external-container d-flex justify-content-center align-items-center py-3">
        <h4>{t('account.title')}</h4>
      </div>
      <div className="d-flex flex-column justify-content-center p-2">
        {tabs.map((tab: any) => (
          <AccountSidebarTab
            key={tab.transKey}
            title={t(`account.${tab.transKey}`)}
            active={activeTab === tab.tab}
            onclick={() => onTabChange(tab.tab)}
            dataTestid={tab.dataTestid}
          />
        ))}
      </div>
    </div>
  )
}
